import React, { useEffect, useMemo, useState } from "react";
import "./Navbar.css";
import { Button } from "./Button";

type Item = { id: string; label: string };

type Props = {
  brand: React.ReactNode;
  items: Item[];
  isOpen: boolean;
  onToggle: () => void;
  onNavigate: () => void;
};

function useScrolled(threshold = 6) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return scrolled;
}

export function Navbar({ brand, items, isOpen, onToggle, onNavigate }: Props) {
  const scrolled = useScrolled(8);

  const primary = useMemo(() => items[items.length - 1]?.id ?? "contacts", [items]);

  const navigate = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    onNavigate();
  };

  return (
    <div className={`navWrap ${scrolled ? "navWrapScrolled" : ""}`}>
      <div className="navInner container">
        <div className="navBrand">{brand}</div>

        <nav className="navDesktop" aria-label="Навигация">
          {items.map((it) => (
            <button key={it.id} className="navLink" onClick={() => navigate(it.id)}>
              {it.label}
            </button>
          ))}
          <Button variant="primary" size="sm" onClick={() => navigate(primary)}>
            Написать
          </Button>
        </nav>

        <button className="burger" onClick={onToggle} aria-label={isOpen ? "Закрыть меню" : "Открыть меню"}>
          <span className={`burgerLine ${isOpen ? "x1" : ""}`} />
          <span className={`burgerLine ${isOpen ? "x2" : ""}`} />
        </button>
      </div>

      <div className={`navMobile ${isOpen ? "navMobileOpen" : ""}`} aria-hidden={!isOpen}>
        <div className="navMobilePanel container">
          <div className="navMobileLinks" role="menu" aria-label="Мобильная навигация">
            {items.map((it) => (
              <button key={it.id} className="navMobileLink" onClick={() => navigate(it.id)} role="menuitem">
                {it.label}
              </button>
            ))}
          </div>
          <div className="navMobileCTA">
            <Button variant="primary" size="md" onClick={() => navigate(primary)}>
              Написать Кристине
            </Button>
            <Button variant="ghost" size="md" onClick={() => navigate("collab")}>
              Форматы и условия
            </Button>
          </div>
          <div className="navMobileNote">
            <span className="navMobileDot" aria-hidden="true" />
            спокойный контент • тёплые смыслы • нативные интеграции
          </div>
        </div>
      </div>
    </div>
  );
}